import { API } from "@/lib/api";
import { BoxemProductFinderCacheResponse, BoxemProductFinderResponse } from "@boxem/core-api-schema";


export function productFinder(query: string): Promise<BoxemProductFinderResponse> {
  return API.post<BoxemProductFinderResponse>("/product-research/", { query });
}

export function productFinderCacheCheck(query: string): Promise<BoxemProductFinderCacheResponse> {
  return API.post<BoxemProductFinderCacheResponse>("/product-research/query-cache", { query });
}
